import useBreakpoint from 'hooks/useBreakpoint';
import Link from 'components/Globals/Base/Link';
import * as S from './BannerStyle';

interface BannerProps {
  desktop?: string;
  mobile?: string;
  link?: string;
  enabled?: boolean;
}

const Banner = ({ desktop = '', mobile = '', link = '', enabled = false }: BannerProps) => {
  const isMobile = useBreakpoint('mdMax');
  if (!enabled || (!desktop && !mobile)) return null;

  const image = isMobile ? mobile : desktop;
  if (!image) return null;

  const imageBanner = <S.Image $url={image} />;
  const isExternal = link && !link.includes('fortune');

  if (!link) return imageBanner;

  if (isExternal) {
    return (
      <Link
        href={link}
        target='_blank'
        rel='noopener noreferrer'
      >
        {imageBanner}
      </Link>
    );
  }

  return (
    <Link
      href={link}
      ariaLabel='Fortune Banner'
    >
      {imageBanner}
    </Link>
  );
};

export default Banner;
